"use strict";

exports.__esModule = true;
exports.PieChartRingSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _helper = require("../../Widgets/MeasureChart/helper");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _numericInputMinMaxSanitizer = require("../../../Utils/numericInputMinMaxSanitizer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MIN_WIDTH = 1;
var MAX_WIDTH = 100;
var PieChartRingSelector = exports.PieChartRingSelector = function PieChartRingSelector(props) {
  var _chartItem$ring, _chartItem$ring2, _chartItem$ring3;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem;
  var ring = chartItem == null ? void 0 : chartItem.ring;
  var defaultRingWidthPercentage = 50;
  var defaultShowLabelInside = false;
  (0, _react.useEffect)(function () {
    if (!ring || Object.entries(ring).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].ring",
          value: el.props.chartItems.props[itemIndex].ring = {
            useRing: false,
            ringWidthPercentage: defaultRingWidthPercentage,
            showLabelInside: defaultShowLabelInside
          }
        };
      });
    }
  }, [ring, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "PieChartRingSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("PieChartRingSelector.ringSettings.label", "Ring settings")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("PieChartRingSelector.ring.useRing.label", "Use ring"),
    "data-testid": "PieChartRingSelector.ring.useRing.switch",
    checked: (_chartItem$ring = chartItem.ring) == null ? void 0 : _chartItem$ring.useRing,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].ring.useRing",
          value: el.props.chartItems.props[itemIndex].ring.useRing = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("PieChartRingSelector.ring.ringWidthPercentage.label", "Ring width percentage"),
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("PieChartRingSelector.ring.ringWidthPercentage.tooltip", "How much space ring uses"),
    position: _core.Position.LEFT
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "PieChartRingSelector.ring.ringWidthPercentage.input",
    min: MIN_WIDTH,
    max: MAX_WIDTH,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].ring.ringWidthPercentage",
          value: el.props.chartItems.props[itemIndex].ring.ringWidthPercentage = (0, _numericInputMinMaxSanitizer.numericInputMinMaxSanitizer)(value, MIN_WIDTH, MAX_WIDTH)
        };
      });
    },
    value: ((_chartItem$ring2 = chartItem.ring) == null ? void 0 : _chartItem$ring2.ringWidthPercentage) || defaultRingWidthPercentage
  }))), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("PieChartRingSelector.ring.showLabelInside.label", "Show label inside"),
    "data-testid": "PieChartRingSelector.ring.showLabelInside.switch",
    checked: (_chartItem$ring3 = chartItem.ring) == null ? void 0 : _chartItem$ring3.showLabelInside,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].ring.showLabelInside",
          value: el.props.chartItems.props[itemIndex].ring.showLabelInside = e.target.checked
        };
      });
    }
  }));
};